import type { QrStyle } from './types';

/** Presets locales (espejo de `qrcl/qr/style.PRESETS`); se reemplazan por los de la API si responde. */
export const CLASSIC_STYLE: QrStyle = {
  module: 'square',
  eyeFrame: 'square',
  eyeBall: 'square',
  color: { fg: '#000000', bg: '#FFFFFF', gradient: { type: 'none', from: '#000000', to: '#000000' }, eyeColor: null },
  logo: null,
  frame: null,
  format: 'png',
};

export const LOCAL_PRESETS: { id: string; label: string; qrStyle: QrStyle }[] = [
  { id: 'clasico', label: 'Clásico', qrStyle: CLASSIC_STYLE },
  {
    id: 'suave',
    label: 'Suave',
    qrStyle: { ...CLASSIC_STYLE, module: 'rounded', eyeFrame: 'rounded', eyeBall: 'rounded', color: { ...CLASSIC_STYLE.color, fg: '#16181D' } },
  },
  {
    id: 'marca',
    label: 'Marca',
    qrStyle: {
      ...CLASSIC_STYLE,
      module: 'rounded',
      eyeFrame: 'rounded',
      eyeBall: 'circle',
      color: { ...CLASSIC_STYLE.color, fg: '#16181D', eyeColor: '#2F6B57' },
      logo: { size: 0.18, pad: 'circle' },
    },
  },
  {
    id: 'menu',
    label: 'Menú',
    qrStyle: {
      ...CLASSIC_STYLE,
      module: 'rounded',
      eyeFrame: 'rounded',
      eyeBall: 'rounded',
      color: { ...CLASSIC_STYLE.color, fg: '#16181D' },
      frame: { text: 'VER MENÚ', color: '#16181D' },
    },
  },
];

export const PRESET_LABELS: Record<string, string> = Object.fromEntries(LOCAL_PRESETS.map((p) => [p.id, p.label]));

export function presetLabel(id: string): string {
  return PRESET_LABELS[id] ?? id.charAt(0).toUpperCase() + id.slice(1);
}

/** Nombre legible de un estilo guardado: el preset que calza exacto o "Personalizado". */
export function describeStyle(style: QrStyle | null | undefined): string {
  if (!style) return 'Clásico';
  const match = LOCAL_PRESETS.find((p) => sameStyle(p.qrStyle, style));
  return match ? match.label : 'Personalizado';
}

function sameStyle(a: QrStyle, b: QrStyle): boolean {
  const norm = (s: QrStyle) =>
    JSON.stringify({
      module: s.module,
      eyeFrame: s.eyeFrame,
      eyeBall: s.eyeBall,
      fg: s.color?.fg?.toUpperCase(),
      bg: s.color?.bg?.toUpperCase(),
      g: s.color?.gradient?.type ?? 'none',
      eye: s.color?.eyeColor?.toUpperCase() ?? null,
      logo: Boolean(s.logo),
      frame: s.frame?.text ?? null,
    });
  return norm(a) === norm(b);
}
